import { ChangeDetectorRef, ViewRef } from '@angular/core';

export const asViewRef = (cdRef: ChangeDetectorRef) => <ViewRef>cdRef;

export const objectKeys = <T extends {}>(obj: T): Array<keyof T> =>
  <Array<keyof T>>Object.keys(obj);
export const objectValues = <T extends {}, U extends keyof T>(obj: T) =>
  <Array<T[U]>>(<unknown>Object.values(obj));

export function bind<T extends (...args: any[]) => any>(
  fn: T,
  thisArg: any,
  ...boundArgs: Parameters<T> | []
): T {
  return fn.bind(thisArg, ...boundArgs);
}

export type SnakeToCamelCase<T extends string> = T extends `${infer W1}_${infer C1}${infer W2}`
  ? `${Lowercase<W1>}${Uppercase<C1>}${SnakeToCamelCase<W2>}`
  : Lowercase<T>;
